import { lazy } from 'react';

// ----------------------------------------------------------------------

const TraineesPage = lazy(() => import('../pages/Trainees.page'));
const AddTraineePage = lazy(() => import('../pages/AddTrainee.page'));
const TraineeDetailsPage = lazy(() => import('../pages/TraineeDetails.page'));

// ----------------------------------------------------------------------
const TraineesRoutes = [
    {
        path: '/human-resources/trainees',
        element: <TraineesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/human-resources/trainees/add-trainee',
        element: <AddTraineePage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/human-resources/trainees/:id',
        element: <TraineeDetailsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { TraineesRoutes };
